import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function HistoryIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M22.5 12C22.5 17.7901 17.7896 22.5 12 22.5C6.21045 22.5 1.5 17.7901 1.5 12H3.5C3.5 16.6865 7.31299 20.5 12 20.5C16.687 20.5 20.5 16.6865 20.5 12C20.5 7.31349 16.687 3.50001 12 3.50001C10.0405 3.50001 8.2002 4.14747 6.67822 5.37208L6.50439 5.5044L9 8.00001H3V2.00001L5.07733 4.0774L5.4458 3.79688C7.2793 2.32129 9.61426 1.5 12 1.5C17.7896 1.5 22.5 6.20996 22.5 12V12ZM11 7.50294V12.6279L16.0001 14.6746V12.5132L13 11.2861V7.50294H11Z",
    fill: "currentColor"
  }));
}